<div class="flex flex-column gap-2 p-1 m-1">
  <div class="flex flex-row flex-wrap">
    <div class="flex flex-1">
      <p-select [options]="fileOptions" [(ngModel)]="file" placeholder="Select a file"></p-select>
    </div>
    <button class="flex flex-none" pButton type="button" label="Import" (click)="importLipidMaps()" [disabled]="!file"></button>
  </div>
  <app-crud-table [title]="'LIPID MAPS Entries'" [columns]="columns" [filterFields]="filterFields" [crudAdapter]="crudAdapter"></app-crud-table>
</div>
